import { Link } from 'react-router-dom';
import PersonalityRadarChart from '../molecules/PersonalityRadarChart';
import PersonaImage from '../molecules/PersonaImage';
import styles from './PassportWidget.module.css';

const EgoLogo = () => (
  <svg viewBox="0 0 100 115.47" className={styles.cardLogo}>
    <defs>
      <linearGradient
        id="goldGradientWidget"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path
      fill="url(#goldGradientWidget)"
      d="M50,0L93.3,25v50L50,100L6.7,75v-50L50,0z M50,10l-34.6,20v40L50,90l34.6-20v-40L50,10z"
    />
    <circle cx="50" cy="45" r="15" fill="url(#goldGradientWidget)" />
    <path
      fill="url(#goldGradientWidget)"
      d="M50,65 C40,65 35,55 35,55 C35,55 40,75 50,75 C60,75 65,55 65,55 C65,55 60,65 50,65z"
    />
  </svg>
);

const PassportWidget = ({ digitalLegacy, planTier, onEdit }) => {
  if (!digitalLegacy) {
    return null;
  }

  const generateEgoId = (userId = '') => {
    const parts = userId
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase()
      .slice(-12);
    if (parts.length < 12) return 'EGO-ID-NOT-AVAILABLE';
    return `EGO-${parts.slice(0, 4)}-${parts.slice(4, 8)}-${parts.slice(8, 12)}`;
  };

  const avatarBorderClass = styles[planTier] || styles.free;

  return (
    <div className={styles.cardWrapper}>
      <button
        onClick={onEdit}
        className={styles.editIcon}
        title="Edit Digital Passport"
      >
        <i className="fas fa-pencil-alt"></i>
      </button>
      <div className={styles.cardBackground}></div>
      <div className={styles.cardContent}>
        <div className={styles.cardHeader}>
          <EgoLogo />
          <span className={styles.protocolTitle}>EGO PROTOCOL</span>
        </div>

        <div className={styles.cardBody}>
          <div className={`${styles.avatarWrapper} ${avatarBorderClass}`}>
            <PersonaImage
              personaId={digitalLegacy.personaId}
              alt={digitalLegacy.personaName}
              className={styles.avatar}
              isOwner={true}
              cacheKey={digitalLegacy.updatedAt}
            />
            <div className={`${styles.planPill} ${avatarBorderClass}`}>
              {planTier}
            </div>
          </div>
          <h3 className={styles.name}>
            <span className={styles.nameText}>{digitalLegacy.personaName}</span>
          </h3>
          <p className={styles.summary}>{digitalLegacy.summary}</p>
        </div>

        <div className={styles.radarChartWrapper}>
          {digitalLegacy.personalityData ? (
            <PersonalityRadarChart
              personalityData={digitalLegacy.personalityData}
            />
          ) : (
            <div className={styles.radarPlaceholder}>
              <i className="fas fa-brain"></i>
              <p>Take the personality test to reveal your core traits.</p>
              <Link to="/personality-test" className={styles.placeholderButton}>
                Take Test
              </Link>
            </div>
          )}
        </div>

        <div className={styles.cardFooter}>
          <div className={styles.footerText}>
            <span className={styles.idLabel}>VERIFIED DIGITAL LEGACY</span>
            <span className={styles.egoId}>
              {generateEgoId(digitalLegacy.userId)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassportWidget;
